import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {Box, Container, Drawer, FormControl, InputLabel, Paper, Select, Stack} from "@mui/material";

import Title from "../Title";
import Success from "../Snackbar/Success";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import countryList from "react-select-country-list";
import Button from "@mui/material/Button";
import BillingInfoForm from "./BillingInfoForm";
import PaymentMethodForm from "./PaymentInfoForm";
import BillingInfoTable from "./BillingInfoTable";
import Api from "../../Services/Api";


const BillingInfo = () => {

    const [apiMessage, setApiMessage] = React.useState(null);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [reload, setReload] = React.useState(false);

    const [drawerBilling, setDrawerBilling] = React.useState(false);


    const [billingInfoForm, setBillingInfoForm] = React.useState([]);


    useEffect(() => {




    }, []);



    const openDrawerByName = (name) => {

        if (name == "payment") {
            setDrawerBilling(false)
        } else {
            setDrawerBilling(true)

        }
        setOpenDrawer(true)
    }


    return (

        <MainLayout>
            <Success successMessage={apiMessage} setSuccessMessage={setApiMessage}>
                {apiMessage?.message}
            </Success>


            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Paper sx={{p: 2}}>
                    <Title>Billing & Payments methods Info</Title>
                    <p>Please choose your payment method and set your billing profile, you can only have one active</p>

                    <Drawer
                        anchor={"right"}
                        open={openDrawer}
                        onClose={() => setOpenDrawer(false)}
                    >
                        {drawerBilling ? <BillingInfoForm form={billingInfoForm} setForm={setBillingInfoForm} setDrawer={setOpenDrawer} setReload={setReload} /> :
                            <PaymentMethodForm form={billingInfoForm} setForm={setBillingInfoForm} setDrawer={setOpenDrawer} setReload={setReload} />}
                    </Drawer>

                    <Box sx={{mt: 3}}>
                        <Title>Existing Billing Info</Title>
                        <Button variant={'contained'} aria-label={'Set a new billing information'}
                                onClick={() => openDrawerByName('billing')}>+ Set a new billing information</Button>

                        <BillingInfoTable type={"billing"} reload={reload} />
                    </Box>
                    <Box sx={{mt: 3}}>
                        <Title>Existing Payment methods</Title>
                        <Button variant={'contained'} aria-label={'Set new payment method'}
                                onClick={() => openDrawerByName('payment')}>+ Set a new payment method</Button>
                        <BillingInfoTable type={"payment"} reload={reload} />
                    </Box>

                </Paper>
            </Container>
        </MainLayout>
    )
}


export default BillingInfo